import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Map from '../components/Map'
import Header from '../components/Header/Header';
import SideBar from '../components/SideBar/SideBar';
import ReservationContent from '../components/ReservationContent/ReservationContent';
import ReservationSuccess from '../components/ReservationSuccess/ReservationSuccess';
import ReservationError from '../components/ReservationError/ReservationError';
import { getCommonData } from '../components/Main/actions';
import { getOfficeInfo } from '../components/ReservationContent/actions';
import { reserveInterval, freeInterval, confirmReservation, clickBtnConfirm, changeInput, timerExpired } from '../components/ReservationContent/actions';
import { regValidatePhone, regValidateEmail } from '../components/ReservationContent/utils';
import { CONTROLLED_INPUT_VALID, CONTROLLED_INPUT_INVALID } from '../globals';


class ReservationPage extends Component {
  constructor(props) {
    super(props);

    const { officeId, serviceId, intervalId } = this.props.params;
    const { getOfficeInfo, officeData, } = this.props;

    getOfficeInfo(officeId);

    this.state = {
      officeId: officeId,
      serviceId: serviceId,
      intervalId: intervalId,
      officeData: officeData.data,
    }

    this.handleOnClickBackToService = this.handleOnClickBackToService.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleOnClickConfirm = this.handleOnClickConfirm.bind(this);
    this.handleTimerExpiration = this.handleTimerExpiration.bind(this);
  }

  componentDidMount() {
    document.title = 'Potvrzení rezervace';

    if (this.props.reservationCommon.status === false)
      this.props.getCommonData();
    
    const { officeId, serviceId, intervalId } = this.state;
    
    this.props.reserveInterval(officeId, serviceId, intervalId);
  }

  componentWillUnmount() {
    if (this.props.reservationState.phase !== 1) {
      const { pin, id } = this.props.reserveData.data;
      this.props.freeInterval(id, pin);
    }
  }

  handleChangeInput(value, inputName) {
    this.props.changeInput(value, inputName);
  }

  handleOnClickConfirm(e) {
    const { name, email, phone, captcha, agreement, note, } = this.props.reservationState.inputs;
    const { reservationCommon } = this.props;

    let newNameValid;
    let newPhoneValid;
    let newAgreement;
    let newNoteValid;

    // check NAME if is enabled and required
    if (reservationCommon.name.show && reservationCommon.name.isRequired)
      newNameValid = name === '' ? CONTROLLED_INPUT_INVALID : CONTROLLED_INPUT_VALID;
    else
      newNameValid = CONTROLLED_INPUT_VALID;

    // check PHONE if is enabled and required
    if (reservationCommon.phone.show && reservationCommon.phone.isRequired)
      newPhoneValid = regValidatePhone.test(phone.replace(/\s+/g, '')) ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID;
    else
      newPhoneValid = CONTROLLED_INPUT_VALID;

    // check NOTE if is enabled and required
    if (reservationCommon.note.show && reservationCommon.note.isRequired)
      newNoteValid = note.length > 0 ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID;
    else
      newNoteValid = CONTROLLED_INPUT_VALID;

    // check AGREEMENT if is enabled
    if (reservationCommon.agreement.show)
      newAgreement = agreement ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID;
    else
      newAgreement = CONTROLLED_INPUT_VALID;

    // check EMAIL
    const newEmailValid = regValidateEmail.test(email) ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID;

    // check CAPTCHA
    const newCaptcha = captcha !== null ? CONTROLLED_INPUT_VALID : CONTROLLED_INPUT_INVALID;

    if (newNameValid === CONTROLLED_INPUT_VALID &&
      newEmailValid === CONTROLLED_INPUT_VALID &&
      newPhoneValid === CONTROLLED_INPUT_VALID &&
      newNoteValid === CONTROLLED_INPUT_VALID &&
      newAgreement === CONTROLLED_INPUT_VALID &&
      newCaptcha === CONTROLLED_INPUT_VALID) {
      const { officeId, serviceId, } = this.state;
      const { id, pin, } = this.props.reserveData.data;
      this.props.confirmReservation({
        id,
        pin,
        name,
        email,
        phone,
        note,
        officeId,
        serviceId,
      });

    } else {
      this.props.clickBtnConfirm(newNameValid, newEmailValid, newPhoneValid, newNoteValid, newAgreement, newCaptcha);
    }
  }

  handleOnClickBackToService(e) {
    const { officeId, serviceId } = this.state;
    this.props.router.push('/office/' + officeId + '/service/' + serviceId);
  }

  handleTimerExpiration() {
    this.props.timerExpired();
  }

  render() {
    const { officeId, serviceId, officeData, } = this.state;
    const {
      reservationCommon,
      btnBackTitle,
      previousSteps,
      reserveData,
      confirmData,
      confirmReservation,
      logo,
      sideBarTitles,
    } = this.props;
    const {
      phase,
      inputs,
      success,
      error,
    } = this.props.reservationState;

    return (
      <div>
        <Header
          logoName={logo.fileName}
          office={officeId}
        />

        <SideBar
          activePage={3}
          officeId={officeId}
          serviceId={serviceId}
          intervalId=''
          titleOne={sideBarTitles.titleOne}
          titleTwo={sideBarTitles.titleTwo}
          titleThree={sideBarTitles.titleThree}
          titleFour={sideBarTitles.titleFour}
        />

        <div className="container-fluid page-header page-sidebar">
          <div className="row page-row">
            <div className="col col-md-6 col-sm-12 page-col">

              {phase === 0 &&
                <ReservationContent
                  btnBackTitle={btnBackTitle}
                  reservationCommon={reservationCommon}
                  previousSteps={previousSteps}
                  serviceId={serviceId}
                  officeId={officeId}
                  officeData={officeData}
                  confirmReservation={confirmReservation}
                  confirmData={confirmData}
                  reserveData={reserveData}
                  inputs={inputs}
                  error={error}
                  clickBtnConfirm={this.handleOnClickConfirm}
                  handleChangeInput={this.handleChangeInput}
                  handleTimerExpiration={this.handleTimerExpiration}
                />
              }

              {phase === 1 &&
                <ReservationSuccess
                  success={success}
                  officeData={officeData}
                  previousSteps={previousSteps}
                  timezone={reserveData.data.timezone}
                />
              }

              {phase === 2 &&
                <ReservationError
                  error={error}
                  officeData={officeData}
                  serviceId={serviceId}
                  officeId={officeId}
                />
              }

            </div>
            <div className="col col-md-6 page-col page-col-hide-md page-col-left-border page-col-fixed">
            <Map officeData={{data: officeData}} height="100vh"
              zoom={13}  />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const { reserveData, confirmData, reservationState, officeData } = state.reservation;
  return {
    reserveData,
    confirmData,
    reservationState,
    officeData,
    reservationCommon: {
      status: state.main.status,
      ...state.main.data.reservationCommon,
    },
    btnBackTitle: state.main.data.intervalsCommon.title,
    previousSteps: state.main.data.previousSteps,
    logo: {
      ...state.main.data.logo,
    },
    sideBarTitles: {
      titleOne: state.main.data.officesCommon.title,
      titleTwo: state.main.data.servicesCommon.title,
      titleThree: state.main.data.intervalsCommon.title,
      titleFour: state.main.data.reservationCommon.title,
    }
  };
}


const mapDispatchToProps = (dispatch) => {
  return {
    getCommonData: bindActionCreators(getCommonData, dispatch),
    reserveInterval: bindActionCreators(reserveInterval, dispatch),
    freeInterval: bindActionCreators(freeInterval, dispatch),
    confirmReservation: bindActionCreators(confirmReservation, dispatch),
    clickBtnConfirm: bindActionCreators(clickBtnConfirm, dispatch),
    changeInput: bindActionCreators(changeInput, dispatch),
    timerExpired: bindActionCreators(timerExpired, dispatch),
    getOfficeInfo: bindActionCreators(getOfficeInfo, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReservationPage);



// WEBPACK FOOTER //
// ./src/pages/Reservation.js